import React from 'react';
import BasePage from './BasePage';

import {Button, ButtonGroup, Card, CardBody, Col, FormGroup, Input, Label, Row, Table} from 'reactstrap';
import modelBanner from 'assets/img/banner/rack.png';
import Page from '../components/Page';
import ActiveOption from '../components/Widget/ActiveOption';
import ItemOption from '../components/Widget/ItemOption';
import Global, {BANNER_IMAGE_MAX_FILE_SIZE, MIME_JPEG, MIME_PNG_JPEG,} from '../utils/Global';
import {imageSelector, isEmpty, isResponseOk, navigateBack} from '../utils/Utilities';
import queryString from 'query-string';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import {getData} from '../utils/StorageUtil';

import {ContentState, convertToRaw, EditorState} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import WarningLabel from '../components/Widget/WarningLabel';
import DateInput from '../components/Widget/DateInput';
import NumberInput from '../components/Widget/NumberInput';
import Checkbox from '../components/Checkbox';
import label from 'enqc-utilities/src/label/Label'

import sanitizeHtml from 'sanitize-html';
import MyCardImage from "../components/Card/MyCardImage";
import {MdAdd, MdArrowBack, MdDelete, MdEdit, MdList, MdSave} from "react-icons/md";
import ComponentSelectionModal from "../components/modal/ComponentSelectionModal";
import ComponentItemInformationModal from "../components/modal/ComponentItemInformationModal";
import ImageCropper from "../components/modal/ImageCropper";
import axios from "axios";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {TYPE_INSPECTION, TYPE_RELEASE_VERIFICATION} from "enqc-utilities/src/utils/Global";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import Endpoint from "enqc-utilities/src/api/Endpoint";

export let PERIOD_TYPES = [
    {
        id:1,
        name:"NEVER_END",
        label:label.NeverEnd,
    },
    {
        id:2,
        name:"PERIODIC",
        label:label.Periodic,
    }
]

export let INSPECTION_LIMIT_TYPES = [
    {
        id:1,
        name:"NO_LIMIT",
        label:label.NoLimit,
    },
    {
        id:2,
        name:"LIMITED",
        label:label.Limited,
    }
]


class ModelDetailPage extends BasePage{
    successToast(message) {
        super.successToast(message);
    }

    constructor(props) {
        super(props);
        let state = this.state
        state.model = {}
        state.validation = {}
        state.periodType = PERIOD_TYPES[0]
        state.inspectionLimitType = INSPECTION_LIMIT_TYPES[0]
        state.modelCategories = []
        state.inspectionGroupFroms = []
        state.releaseVerificationGroupForms = []
        state.iconPhoto  = undefined
        state.labelImageAttachment = undefined
        state.modelIdQuery = queryString.parse(this.props.query).id
        state.modelCategory = {}
        state.modalAddConfirm = false
        state.modalDeleteConfirm = false
        state.inventories = []
        state.inventory = undefined
        state.ascending = true
        state.sortir = 'created'
        state.quantityModal = false
        state.page = queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1
        state.totalPage = 0
        state.totalElement = 0
        state.pageElement = 0
        state.scopeEditorState = EditorState.createEmpty()
        state.referenceDocumentEditorState = EditorState.createEmpty()
        state.testingEquipmentAndAccessoriesEditorState = EditorState.createEmpty()
        state.validation = {}
        state.systemSpecifications = []
        state.componentPageSelectionModal = false
        state.componentItemInformationModal = false
        state.partNumberAlreadyBeenUsed = false
        this.setState(state)
    }

    async componentDidMount() {
        super.componentDidMount();
        await this.fetchGroupForms()
        await this.fetchReleaseVerificationGroupForms()
        await this.fetchModelDetail(this.state.modelIdQuery)
        await this.fetchAllCategories()
    }

    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props){
            this.setState({
                page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
            }, () => {
                // this.fetchAllInventories(this.state.model.id, this.state.ascending, this.state.sortir, true)
            })
        }
    }

    onScopeEditorStateChange= (scopeEditorState) => {
        let {model, validation} = this.state
        model.scope = draftToHtml(convertToRaw(scopeEditorState.getCurrentContent()))
        validation.scope = undefined
        this.setState({
            model:model,
            scopeEditorState:scopeEditorState,
            validation:validation
        });
    }

    onReferenceDocumentEditorStateChange= (referenceDocumentEditorState) => {
        let {model, validation} = this.state
        model.referenceDocument = draftToHtml(convertToRaw(referenceDocumentEditorState.getCurrentContent()))
        validation.referenceDocument = undefined
        this.setState({
            model:model,
            referenceDocumentEditorState:referenceDocumentEditorState,
        });
    }

    onTestingEquipmentAndAccessoriesEditorStateChange= (testingEquipmentAndAccessoriesEditorState) => {
        let {model, validation} = this.state
        model.testingEquipmentAndAccessories = draftToHtml(convertToRaw(testingEquipmentAndAccessoriesEditorState.getCurrentContent()))
        validation.testingEquipmentAndAccessories = undefined
        this.setState({
            model:model,
            testingEquipmentAndAccessoriesEditorState:testingEquipmentAndAccessoriesEditorState,
        });
    }


    confirmSave = async () =>{
        let {model, validation, iconPhoto, labelImageAttachment} = this.state
        let valid = true ;
        if(isEmpty(model.modelName)){
            validation.modelName = label.EnterModelName
            valid = false ;
        }
        if(isEmpty(model.systemType)){
            validation.systemType = label.EnterSystemType
            valid = false ;
        }

        if(isEmpty(model.partName)){
            validation.partName = label.EnterPartName
            valid = false ;
        }

        if(isEmpty(model.partNumber)){
            validation.partNumber = label.EnterPartNumber
            valid = false ;
        }else{
            this.showProgress()
            valid = (await this.validatePartNumber())
            this.closeProgress()
        }

        if(isEmpty(model.acInput)){
            validation.acInput = label.EnterACInput
            valid = false ;
        }

        if(isEmpty(model.frequency)){
            validation.frequency = label.EnterFrequency
            valid = false ;
        }

        if(isEmpty(model.acInputCurrent)){
            validation.acInputCurrent = label.EnterACInputCurrent
            valid = false ;
        }

        if(isEmpty(model.dcOutput)){
            validation.dcOutput = label.EnterDCOutput
            valid = false ;
        }

        if(isEmpty(model.polarity)){
            validation.polarity = label.EnterPolarity
            valid = false ;
        }
        if(isEmpty(model.warranty)){
            validation.warranty = label.EnterWarranty
            valid = false ;
        }

        if(isEmpty(model.groupForm)){
            validation.groupForm = label.PleaseSelectGroupForm
            valid = false ;
        }

        if(isEmpty(model.releaseVerificationGroupForm)){
            validation.releaseVerificationGroupForm = label.PleaseSelectReleaseVerificationGroupForm
            valid = false ;
        }

        if(model.inspectionLimitType===INSPECTION_LIMIT_TYPES[1].name){
            if(model.inspectionLimitPerUser && model.inspectionLimitPerUser>model.inspectionLimitCount){
                validation.inspectionLimitPerUser = label.MaxUsagePerUserCannotBeLargerThanMaxUsageGeneral
                valid = false ;
            }
            if(model.inspectionLimitCount && model.inspectionLimitCount<model.inspectionCount){
                validation.inspectionLimitCount = label.MaxUsageCannotBeSmallerThanCurrentUsage
                valid = false ;
            }
        }
        if(isEmpty(model.description) || model.description.trim() === '<p></p>'){
            validation.description = label.PleaseEnterDescription
            valid = false ;
        }
        if(isEmpty(model.referenceDocument) || model.referenceDocument.trim() === '<p></p>'){
            validation.referenceDocument = label.PleaseEnterReferenceDocument
            valid = false ;
        }
        if(isEmpty(model.modelCategory)){
            validation.modelCategory = label.EnterModelCategoryName
            valid = false ;
        }
        this.setState({validation, modalAddConfirm:valid}, () => {
            if(!valid){
                alert(label.YouHaveSomeIssueOnTheInputForm_PleaseCheckItAccordingly)
                // alert(JSON.stringify(validation))
            }
        })
    }

    confirmDelete = () =>{
        this.setState({
            modalDeleteConfirm:true
        })
    }

    delete = () => {
        if(this.state.inventory!=undefined){
            this.setState({
                modalDeleteConfirm:false
            }, () => {
                this.get(Global.API.INVENTORY_DELETE+"/"+this.state.inventory.id, undefined, undefined, res => {
                    if(res.code===200){
                        this.setState({
                            inventory:undefined
                        }, () => {
                            // this.fetchAllInventories(this.state.model.id, this.state.ascending, this.state.sortir, true)
                        })
                    }
                }, true, true);
            })
        }
    }

    saveUpload = (model, systemSpecifications) => {
        let {iconPhotoBlob, labelImageAttachmentBlob} = this.state
        var formData = new FormData();
        let newData = !model.id
        let inspectionLimitType = this.state.inspectionLimitType
        model.inspectionLimitType = inspectionLimitType.name
        let periodType = this.state.periodType
        model.periodType = periodType.name
        model.systemSpecifications = systemSpecifications

        formData.append("modelDtoGson", JSON.stringify(model))
        formData.append("iconPhotoMultipartFile", iconPhotoBlob);
        formData.append("labelImageAttachmentMultipartFile", labelImageAttachmentBlob);
        this.setState({
            modalAddConfirm:false
        }, () => {
            this.post(Global.API.MODEL_SAVE_UPLOAD, formData, undefined, res=>{
                if(res.code===200){
                    this.successToast(label.SuccessUpdatingData)
                    let model = res.data
                    if(newData){
                        this.props.history.goBack()
                        window.location.href = ModelDetailPage.ENDPOINT+"?id="+model.id
                    }else{
                        // window.location.reload()
                        this.setState({
                            model : model
                        }, async () => {
                            await this.fetchModelDetail(model.id)
                        })

                    }

                }
            },  true, true)
        })
    }


    fetchModelDetail = async (id) => {
        if(id){
            let response = await this.asyncGet(Global.API.MODEL, {
                params :{
                    id : id
                }
            }, undefined, true, true)
            if(response.code===200){
                let model = response.data
                let scopeEditorState = this.state.scopeEditorState
                if(model.scope){
                    const scopeContentBlock = htmlToDraft(sanitizeHtml(model.scope));
                    if (scopeContentBlock) {
                        let contentState = ContentState.createFromBlockArray(scopeContentBlock.contentBlocks);
                        scopeEditorState = EditorState.createWithContent(contentState);
                    }else{
                        scopeEditorState = EditorState.createEmpty()
                    }
                }else{
                    scopeEditorState = EditorState.createEmpty()
                }
                let referenceDocumentEditorState = this.state.referenceDocumentEditorState
                if(model.referenceDocument){
                    const referenceDocumentContentBlock = htmlToDraft(sanitizeHtml(model.referenceDocument));
                    if (referenceDocumentContentBlock) {
                        let contentState = ContentState.createFromBlockArray(referenceDocumentContentBlock.contentBlocks);
                        referenceDocumentEditorState = EditorState.createWithContent(contentState);
                    }else{
                        referenceDocumentEditorState = EditorState.createEmpty()
                    }
                }else{
                    referenceDocumentEditorState = EditorState.createEmpty()
                }

                let testingEquipmentAndAccessoriesEditorState = this.state.testingEquipmentAndAccessoriesEditorState
                if(model.testingEquipmentAndAccessories){
                    const testingEquipmentAndAccessoriesContentBlock = htmlToDraft(sanitizeHtml(model.testingEquipmentAndAccessories));
                    if (testingEquipmentAndAccessoriesContentBlock) {
                        let contentState = ContentState.createFromBlockArray(testingEquipmentAndAccessoriesContentBlock.contentBlocks);
                        testingEquipmentAndAccessoriesEditorState = EditorState.createWithContent(contentState);
                    }else{
                        testingEquipmentAndAccessoriesEditorState = EditorState.createEmpty()
                    }
                }else{
                    testingEquipmentAndAccessoriesEditorState = EditorState.createEmpty()
                }


                let periodType = this.state.periodType?this.state.periodType:PERIOD_TYPES[0]
                if(model.periodType){
                    PERIOD_TYPES.forEach(value => {
                        if(value.name===model.periodType){
                            periodType=value
                        }
                    })
                }
                let inspectionLimitType = this.state.inspectionLimitType?this.state.inspectionLimitType:INSPECTION_LIMIT_TYPES[0]
                if(model.inspectionLimitType){
                    INSPECTION_LIMIT_TYPES.forEach(value => {
                        if(value.name===model.inspectionLimitType){
                            inspectionLimitType = value ;
                        }
                    })
                }
                let systemSpecifications = model.systemSpecifications
                this.setState({
                    model:model,
                    systemSpecifications:systemSpecifications,
                    modelCategory:model.modelCategory,
                    iconPhoto:model.iconPhotoUrl,
                    labelImageAttachment:model.labelImageAttachmentUrl,
                    periodType:periodType,
                    inspectionLimitType:inspectionLimitType,
                    scopeEditorState:scopeEditorState,
                    referenceDocumentEditorState:referenceDocumentEditorState,
                    testingEquipmentAndAccessoriesEditorState:testingEquipmentAndAccessoriesEditorState,
                })
            }else{
                this.props.history.goBack();
            }

        }
    }


    fetchAllCategories = async () =>{
        let {model} = this.state
        if(!model){
            model = {}
        }
        // if(!model.id){
        //     return ;
        // }
        let type = model.id?model.type:undefined
        let response = await this.asyncGet(Global.API.MODEL_CATEGORIES, {
            params:{
                active:true,
                type : type,
            }
        }, undefined, true, true);
        if(response.code === 200){
            this.setState({
                modelCategories : response.data
            })
        }

    }

    fetchGroupForms = async () => {
        let {ascending, sortir} = this.state
        let response = await this.asyncGet(Global.API.GROUP_FORMS, {
            params:{
                type: TYPE_INSPECTION,
                page: undefined,
                ascending:ascending,
                sortir:sortir,
            }
        }, undefined, true, true);
        if(response.code === 200){
            this.setState({
                inspectionGroupFroms : response.data,
                totalPage: response.totalPage,
                totalElement: response.totalElement,
                pageElement: response.pageElement,

            })
        }

    }

    fetchReleaseVerificationGroupForms = async () => {
        let {ascending, sortir} = this.state
        let response = await this.asyncGet(Global.API.GROUP_FORMS, {
            params:{
                type: TYPE_RELEASE_VERIFICATION,
                page: undefined,
                ascending:ascending,
                sortir:sortir,
            }
        }, undefined, true, true);
        if(response.code === 200){
            this.setState({
                releaseVerificationGroupForms : response.data,
                totalPage: response.totalPage,
                totalElement: response.totalElement,
                pageElement: response.pageElement,

            })
        }

    }

    closeDialog = () =>{
        this.setState({
            modalAddConfirm:false,
            modalDeleteConfirm:false,
        })
    }

    refreshInventory = (ascending, sortir, progressing) => (
        this.setState({
            ascending:ascending,
            sortir:sortir
        }, () => {
            // this.fetchAllInventories(this.state.model.id, this.state.ascending, this.state.sortir, progressing)
        })
    )

    openQuantityModal=()=>{
        this.setState({
            quantityModal:true
        })
    }


    closeQuantityModal=()=>{
        this.setState({
            quantityModal:false
        })
    }

    async validatePartNumber (){
        let {model, validation} = this.state
        let response = await this.asyncGet(Endpoint.API.MODEL_VALIDATE_PART_NUMBER, {params:{partNumber:model.partNumber, id:model.id}}, false, false);
        if(isResponseOk(response)){
            let partNumberAlreadyBeenUsed = response.data===true
            if(partNumberAlreadyBeenUsed) {
                validation.partNumber = response.message
            }
            this.setState({validation})
            return !partNumberAlreadyBeenUsed
        }
        return true
    }


    render() {
        let {model, systemSpecifications, componentPageSelectionModal, componentItemInformationModal, modelCategories,
            inspectionGroupFroms, releaseVerificationGroupForms,
            scopeEditorState, referenceDocumentEditorState, testingEquipmentAndAccessoriesEditorState, tags, periodType, inspectionLimitType, validation,
            modalDeleteConfirm, modalAddConfirm, iconPhotoCropperModal, iconPhoto, labelImageAttachmentCropperModal, labelImageAttachment, partNumberAlreadyBeenUsed} = this.state
        var ids = [];
        var labels = [];
        if(!modelCategories){
            modelCategories = []
        }
        modelCategories.map((item, index)=>{
            ids.push(item.id);
            labels.push(item.name);
        })

        let configuration = getData(Global.CONFIGURATION)
        let iconPhotoAspect = 10/10
        let labelImageAttachmentAspect = undefined

        if(!tags){
            tags = []
        }
        if(!periodType){
            periodType = {}
        }
        if(!inspectionLimitType){
            inspectionLimitType = {}
        }
        if(!validation){
            validation = {}
        }

        return (
            <Page
                title={label.ModelDetail}
                breadcrumbs={[{ name: label.ModelDetail, active: true }]}>
                {super.render()}
                <ConfirmDialog
                    showing={modalAddConfirm}
                    title={label.UpdateConfirmation}
                    message={label.UpdateConfirmationMessage}
                    okCallback={()=>{
                        this.saveUpload(model, systemSpecifications)
                    }}
                    cancelCallback={this.closeDialog}/>
                <ConfirmDialog
                    showing={modalDeleteConfirm}
                    title={label.DeleteConfirmationTitle}
                    message={label.DeleteConfirmationMessage}
                    okCallback={this.delete}
                    cancelCallback={this.closeDialog}/>
                <Row key={1}>
                    <Col>
                        <Card>
                            <PrimaryCardHeader
                                content={(
                                    <React.Fragment>
                                        <Row className="p-0">
                                            <Col className="m-0 align-content-center">
                                                {label.ModelProperties}
                                            </Col>
                                            <Col className="m-0">
                                                <ButtonGroup className="float-right">
                                                    <Button color="danger" onClick={e => (
                                                        this.setState({
                                                            model:{}
                                                        }, () => {
                                                            navigateBack(this.props)
                                                        })
                                                    )}>
                                                        <MdArrowBack/>&nbsp;{label.Back}
                                                    </Button>
                                                    &nbsp;
                                                    <Button color="primary" onClick={e=>{
                                                        e.preventDefault()
                                                        this.confirmSave()
                                                    }}> {
                                                        (model&& model.id)?label.Update:label.Create
                                                    }&nbsp; <MdSave/></Button>
                                                </ButtonGroup>
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                )}/>
                            <CardBody>
                                <Row>
                                    <Col>
                                        <Card>
                                            <PrimaryCardHeader content={label.BasicInformation}/>
                                            <CardBody>
                                                <Row>
                                                    <Col md={9}>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label for="name">{label.ModelName}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="modelName"
                                                                        value={(model&&model.modelName)?model.modelName:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            model.modelName = e.target.value
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterModelName}
                                                                    />
                                                                    <WarningLabel show={validation.modelName} message={label.EnterModelName}/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label for="name">{label.SystemType}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="title"
                                                                        value={(model&&model.systemType)?model.systemType:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            model.systemType = e.target.value
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterSystemType}
                                                                    />
                                                                    <WarningLabel show={validation.systemType} message={label.EnterSystemType}/>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="partName">{label.PartName}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="partName"
                                                                        value={(model&&model.partName)?model.partName:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            model.partName = e.target.value
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterPartName}
                                                                    />
                                                                    <WarningLabel show={validation.partName} message={label.EnterPartName}/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="pn">{label.PartNumber}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="pn"
                                                                        value={(model&&model.partNumber)?model.partNumber:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            let value = e.target.value
                                                                            model.partNumber = value
                                                                            this.setState({model}, async () => {
                                                                                await this.validatePartNumber()
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterPn}
                                                                    />
                                                                    <WarningLabel show={validation.partNumber} message={validation.partNumber}/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="pn">{label.ACInput}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="acInput"
                                                                        value={(model&&model.acInput)?model.acInput:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            model.acInput = e.target.value
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterACInput}
                                                                    />
                                                                    <WarningLabel show={validation.acInput} message={label.EnterACInput}/>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="frequency">{label.Frequency}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="frequency"
                                                                        value={(model&&model.frequency)?model.frequency:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            model.frequency = e.target.value
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterFrequency}
                                                                    />
                                                                    <WarningLabel show={validation.frequency} message={label.EnterFrequency}/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="pn">{label.ACInputCurrent}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="acInputCurrent"
                                                                        value={(model&&model.acInputCurrent)?model.acInputCurrent:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            model.acInputCurrent = e.target.value
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterACInputCurrent}
                                                                    />
                                                                    <WarningLabel show={validation.acInputCurrent} message={label.EnterACInputCurrent}/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="pn">{label.DCOutput}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="dcOutput"
                                                                        value={(model&&model.dcOutput)?model.dcOutput:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            model.dcOutput = e.target.value
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterDCOutput}
                                                                    />
                                                                    <WarningLabel show={validation.dcOutput} message={label.EnterDCOutput}/>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="polarity">{label.Polarity}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="polarity"
                                                                        value={(model&&model.polarity)?model.polarity:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            model.polarity = e.target.value
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterPolarity}
                                                                    />
                                                                    <WarningLabel show={validation.polarity} message={label.EnterPolarity}/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="warranty">{label.Warranty}</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="warranty"
                                                                        value={(model&&model.warranty)?model.warranty:""}
                                                                        onChange={(e) =>{
                                                                            e.preventDefault()
                                                                            let warranty = e.target.value
                                                                            warranty = warranty.replace(/\D/g,'')
                                                                            model.warranty = warranty
                                                                            this.setState({
                                                                                model:model
                                                                            })
                                                                        }}
                                                                        placeholder={label.EnterWarranty}
                                                                    />
                                                                    <WarningLabel show={validation.warranty} message={label.EnterWarranty}/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <ActiveOption
                                                                        label={label.Publication}
                                                                        trueLabel={label.Published}
                                                                        falseLabel={label.Unpublished}
                                                                        callback={(active)=>{
                                                                            model.published = active
                                                                            this.setState({
                                                                                model
                                                                            })

                                                                        }}
                                                                        default={model?model.published:false}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <FormGroup>
                                                            <Label for="name">{label.Description}</Label>
                                                            <Input
                                                                type="textarea"
                                                                name="description"
                                                                value={(model&& model.description)?model.description:""}
                                                                style={{height:'75px', verticalAlign:'text-top'}}
                                                                align={"top"}
                                                                onChange={(e) =>{
                                                                    e.preventDefault()
                                                                    model.description = e.target.value
                                                                    this.setState({
                                                                        model
                                                                    })
                                                                }}
                                                                placeholder={label.EnterDescription}
                                                            />
                                                            <WarningLabel show={validation.description} message={label.EnterDescription}/>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.Period}
                                                                objects={PERIOD_TYPES}
                                                                fieldForLabel={"label"}
                                                                default={periodType?periodType.id:undefined}
                                                                hideOptionLabel={true}
                                                                callback={(periodType)=>{
                                                                    model.periodType = periodType.name
                                                                    this.setState({
                                                                        model:model,
                                                                        periodType:periodType
                                                                    })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                        {
                                                            (model.periodType===PERIOD_TYPES[1].name)?(
                                                                <Row>
                                                                    <Col>
                                                                        <Label for="startPeriod">{label.StartPeriod}</Label>
                                                                        <DateInput
                                                                            id="startPeriod"
                                                                            maxdate={model.endPeriod}
                                                                            mindate={new Date()}
                                                                            value={model.startPeriod}
                                                                            onChange={(e) =>{
                                                                                let value = e.target.value
                                                                                model.startPeriod = value
                                                                                this.setState({
                                                                                    model : model
                                                                                })
                                                                            }}
                                                                            placeholder={label.EnterStartPeriod}>
                                                                        </DateInput>
                                                                    </Col>
                                                                    <Col>
                                                                        <Label for="endPeriod">{label.EndPeriod}</Label>
                                                                        <DateInput
                                                                            id="endPeriod"
                                                                            maxdate={undefined}
                                                                            mindate={model.startPeriod}
                                                                            value={model.endPeriod}
                                                                            onChange={(e) =>{
                                                                                let value = e.target.value
                                                                                model.endPeriod = value
                                                                                this.setState({
                                                                                    model : model
                                                                                })
                                                                            }}
                                                                            placeholder={label.EnterEndPeriod}>
                                                                        </DateInput>
                                                                    </Col>
                                                                </Row>
                                                            ):(undefined)
                                                        }
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.MaximumInspectionCanBeApplied}
                                                                objects={INSPECTION_LIMIT_TYPES}
                                                                fieldForLabel={"label"}
                                                                default={inspectionLimitType?inspectionLimitType.id:undefined}
                                                                hideOptionLabel={true}
                                                                callback={(inspectionLimitType)=>{
                                                                    model.inspectionLimitType = inspectionLimitType.name
                                                                    this.setState({
                                                                        model:model,
                                                                        inspectionLimitType:inspectionLimitType
                                                                    })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                        {
                                                            model.inspectionLimitType===INSPECTION_LIMIT_TYPES[1].name&&(
                                                                <Row>
                                                                    <Col>
                                                                        <FormGroup>
                                                                            <Label for="inspectionLimitCount">{label.MaximumApplicationUsage}</Label>
                                                                            <NumberInput
                                                                                name="inspectionLimitCount"
                                                                                className="form-control"
                                                                                value={!isEmpty(model.inspectionLimitCount)?model.inspectionLimitCount:""}
                                                                                onChangeEvent={(e, maskedvalue, floatvalue) => {
                                                                                    e.preventDefault()
                                                                                    model.inspectionLimitCount = floatvalue
                                                                                    validation.inspectionLimitCount = undefined
                                                                                    this.setState({
                                                                                        model: model,
                                                                                        validation:validation
                                                                                    })
                                                                                }}
                                                                                placeholder="0"
                                                                                maxLength={15}>
                                                                            </NumberInput>
                                                                            <WarningLabel show={validation.inspectionLimitCount} message={validation.inspectionLimitCount}/>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col>
                                                                        <FormGroup>
                                                                            <Label for="inspectionCount">{label.CurrentApplicationUsage}</Label>
                                                                            <NumberInput
                                                                                name="inspectionCount"
                                                                                className="form-control"
                                                                                value={!isEmpty(model.inspectionCount)?model.inspectionCount:""}
                                                                                placeholder="0"
                                                                                maxLength={15}
                                                                                disabled={true}>
                                                                            </NumberInput>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        }
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label for="inspectionLimitPerUser">{label.MaxInspectionPerUserDefaultUnlimitedPlaceholder}</Label>
                                                                    <NumberInput
                                                                        name="inspectionLimitPerUser"
                                                                        className="form-control"
                                                                        value={!isEmpty(model.inspectionLimitPerUser)?model.inspectionLimitPerUser:""}
                                                                        placeholder={label.MaxInspectionPerUserDefaultUnlimitedPlaceholder}
                                                                        maxLength={9}
                                                                        onChangeEvent={(e, maskedvalue, floatvalue) => {
                                                                            e.preventDefault()
                                                                            model.inspectionLimitPerUser = floatvalue
                                                                            validation.inspectionLimitPerUser = undefined
                                                                            this.setState({
                                                                                model: model,
                                                                                validation:validation
                                                                            })
                                                                        }}>
                                                                    </NumberInput>
                                                                    <WarningLabel show={validation.inspectionLimitPerUser} message={validation.inspectionLimitPerUser}/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label for="suggestion">{label.Suggestion}</Label>
                                                                    <NumberInput
                                                                        name="suggestion"
                                                                        className="form-control"
                                                                        value={!isEmpty(model.suggestion)?model.suggestion:""}
                                                                        onChangeEvent={(e, maskedvalue, floatvalue) => {
                                                                            e.preventDefault()
                                                                            model.suggestion = floatvalue
                                                                            this.setState({
                                                                                model: model
                                                                            })
                                                                        }}
                                                                        placeholder="0"
                                                                        maxLength={15}>
                                                                    </NumberInput>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Row>
                                                            <Col>
                                                                <Card>
                                                                    <PrimaryCardHeader content={label.ModelPhoto}/>
                                                                    <CardBody>
                                                                        <MyCardImage
                                                                            top
                                                                            src={iconPhoto?iconPhoto:modelBanner}
                                                                            onError={(elm)=>this.defaultImage(elm, modelBanner)}
                                                                            onClick={e=>{
                                                                                imageSelector(file=>{
                                                                                    this.setState({
                                                                                        iconPhoto:file,
                                                                                        iconPhotoCropperModal:true
                                                                                    })
                                                                                }, MIME_JPEG, BANNER_IMAGE_MAX_FILE_SIZE).click()
                                                                            }}/>
                                                                        <br/>
                                                                        <br/>
                                                                        <span>{label.ModelIconRatio}</span>
                                                                        <Row>
                                                                            <Col>
                                                                                <WarningLabel message={label.UseImageTypeInstruction("jpeg", BANNER_IMAGE_MAX_FILE_SIZE)}/>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col>
                                                                                <ButtonGroup className="float-left">
                                                                                    <Button color="danger" onClick={e => (
                                                                                        this.setState({
                                                                                            iconPhoto:model.iconPhotoUrl
                                                                                        })
                                                                                    )}>{label.Cancel}</Button>
                                                                                </ButtonGroup>
                                                                            </Col>
                                                                            <Col>
                                                                                <ButtonGroup className="float-right">
                                                                                    <Button color="primary" onClick={e=>{
                                                                                        imageSelector(file=>{
                                                                                            this.setState({
                                                                                                iconPhoto:file,
                                                                                                iconPhotoCropperModal:true
                                                                                            })
                                                                                        }, MIME_JPEG, BANNER_IMAGE_MAX_FILE_SIZE).click()
                                                                                    }}>{label.Upload}</Button>
                                                                                </ButtonGroup>
                                                                            </Col>
                                                                        </Row>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Card>
                                                                    <PrimaryCardHeader content={label.LabelPhoto}/>
                                                                    <CardBody>
                                                                        <MyCardImage
                                                                            top
                                                                            style={{opacity:labelImageAttachment?1.0:0.2}}
                                                                            src={labelImageAttachment?labelImageAttachment:ApplicationIcons.Icons.pngImage}
                                                                            onError={(elm)=>this.defaultImage(elm, ApplicationIcons.Icons.pngImage)}
                                                                            onClick={e=>{
                                                                                imageSelector(file=>{
                                                                                    this.setState({
                                                                                        labelImageAttachment:file,
                                                                                        labelImageAttachmentCropperModal:true
                                                                                    })
                                                                                }, MIME_PNG_JPEG, BANNER_IMAGE_MAX_FILE_SIZE).click()
                                                                            }}/>
                                                                        <br/>
                                                                        <br/>
                                                                        <span>{label.LabelImageAttachmentRatio}</span>
                                                                        <Row>
                                                                            <Col>
                                                                                <WarningLabel message={label.UseImageTypeInstruction("jpeg", BANNER_IMAGE_MAX_FILE_SIZE)}/>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col>
                                                                                <ButtonGroup className="float-left">
                                                                                    <Button color="danger" onClick={e => (
                                                                                        this.setState({
                                                                                            labelImageAttachment:model.labelImageAttachmentUrl
                                                                                        })
                                                                                    )}>{label.Cancel}</Button>
                                                                                </ButtonGroup>
                                                                            </Col>
                                                                            <Col>
                                                                                <ButtonGroup className="float-right">
                                                                                    <Button color="primary" onClick={e=>{
                                                                                        imageSelector(file=>{
                                                                                            this.setState({
                                                                                                labelImageAttachment:file,
                                                                                                labelImageAttachmentCropperModal:true
                                                                                            })
                                                                                        }, MIME_JPEG, BANNER_IMAGE_MAX_FILE_SIZE).click()
                                                                                    }}>{label.Upload}</Button>
                                                                                </ButtonGroup>
                                                                            </Col>
                                                                        </Row>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card>
                                            <PrimaryCardHeader content={label.ComponentInformation}/>
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.SelectCategory}
                                                                objects={this.state.modelCategories}
                                                                default={this.state.modelCategory?this.state.modelCategory.id:undefined}
                                                                noTranslation={true}
                                                                callback={(modelCategory)=>{
                                                                    model.modelCategory = modelCategory
                                                                    this.setState({
                                                                        model:model,
                                                                        modelCategory:modelCategory,
                                                                    })
                                                                }}
                                                            />
                                                            <WarningLabel show={validation.modelCategory} message={validation.modelCategory}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.GroupForm}
                                                                objects={inspectionGroupFroms}
                                                                default={model.groupForm?model.groupForm.id:undefined}
                                                                noTranslation={true}
                                                                callback={(groupForm)=>{
                                                                    model.groupForm = groupForm
                                                                    validation.groupForm = undefined
                                                                    this.setState({
                                                                        model:model,
                                                                        groupForm:groupForm,
                                                                        validation:validation
                                                                    })
                                                                }}
                                                            />
                                                            <WarningLabel show={validation.groupForm} message={validation.groupForm}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.ReleaseVerificationGroupForm}
                                                                objects={releaseVerificationGroupForms}
                                                                default={model.releaseVerificationGroupForm?model.releaseVerificationGroupForm.id:undefined}
                                                                noTranslation={true}
                                                                callback={(groupForm)=>{
                                                                    model.releaseVerificationGroupForm = groupForm
                                                                    validation.releaseVerificationGroupForm = undefined
                                                                    this.setState({
                                                                        model:model,
                                                                        releaseVerificationGroupForm:groupForm,
                                                                        validation:validation
                                                                    })
                                                                }}
                                                            />
                                                            <WarningLabel show={validation.releaseVerificationGroupForm} message={validation.releaseVerificationGroupForm}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <Label for="suggestion">{label.SizeOfRectifierControllerSerialNumber}</Label>
                                                            <NumberInput
                                                                name="suggestion"
                                                                className="form-control"
                                                                value={!isEmpty(model.sizeOfRectifierControllerSerialNumber)?model.sizeOfRectifierControllerSerialNumber:""}
                                                                onChangeEvent={(e, maskedvalue, floatvalue) => {
                                                                    e.preventDefault()
                                                                    model.sizeOfRectifierControllerSerialNumber = floatvalue
                                                                    this.setState({
                                                                        model: model
                                                                    })
                                                                }}
                                                                placeholder="0"
                                                                maxLength={15}>
                                                            </NumberInput>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card>
                                            <PrimaryCardHeader content={label.Scope}/>
                                            <CardBody>
                                                <Editor
                                                    editorState={scopeEditorState}
                                                    onEditorStateChange={this.onScopeEditorStateChange}/>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col>
                                        <Card>
                                            <PrimaryCardHeader content={label.ReferenceDocument}/>
                                            <CardBody>
                                                <Editor
                                                    editorState={referenceDocumentEditorState}
                                                    onEditorStateChange={this.onReferenceDocumentEditorStateChange}/>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card>
                                            <PrimaryCardHeader content={label.TestingEquipmentAndAccessories}/>
                                            <CardBody>
                                                <Editor
                                                    editorState={testingEquipmentAndAccessoriesEditorState}
                                                    onEditorStateChange={this.onTestingEquipmentAndAccessoriesEditorStateChange}/>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col>
                                        {this.renderSystemSpecification(systemSpecifications, model)}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <ImageCropper
                    src={iconPhoto}
                    aspect={iconPhotoAspect}
                    show={iconPhotoCropperModal}
                    callback={file=>{
                        axios({
                            url: file,
                            method: 'GET',
                            responseType: 'blob',
                        }).then((response) => {
                            let fileBlob = response.data ;
                            this.setState({
                                iconPhoto:file,
                                iconPhotoCropperModal:false,
                                iconPhotoBlob:fileBlob,
                            })
                        })
                    }}
                    cancelCallback={()=>{
                        this.setState({
                            iconPhotoCropperModal:false,
                            iconPhoto:model.iconPhotoUrl,
                            iconPhotoBlob:undefined,
                        })
                    }
                    }/>
                <ImageCropper
                    src={labelImageAttachment}
                    aspect={labelImageAttachmentAspect}
                    freeTransform={true}
                    show={labelImageAttachmentCropperModal}
                    callback={file=>{
                        axios({
                            url: file,
                            method: 'GET',
                            responseType: 'blob',
                        }).then((response) => {
                            let fileBlob = response.data ;
                            this.setState({
                                labelImageAttachment:file,
                                labelImageAttachmentCropperModal:false,
                                labelImageAttachmentBlob:fileBlob,
                            })
                        })
                    }}
                    cancelCallback={()=>{
                        this.setState({
                            labelImageAttachmentCropperModal:false,
                            labelImageAttachment:model.labelImageAttachmentUrl,
                            labelImageAttachmentBlob:undefined,
                        })
                    }
                    }/>
            </Page>
        );
    }


    renderSystemSpecification(systemSpecifications, model) {
        return (
            <Row>
                <Col>
                    <Card>
                        <PrimaryCardHeader
                            content={(
                                <React.Fragment>
                                    {label.SystemSpecification}
                                    <Button style={{ float: 'right' }} onClick={() => {
                                        // systemSpecifications.push({ })
                                        this.setState({
                                            systemSpecifications: [...systemSpecifications, {id:-(systemSpecifications.length+1)}]
                                        })
                                    }}><MdAdd /></Button>
                                </React.Fragment>
                            )}/>
                        <CardBody>
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th width={'5%'}>#</th>
                                    <th width={'30%'}>{label.Label}</th>
                                    <th width={'55%'}>{label.Description}</th>
                                    <th>{label.Remove}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    systemSpecifications.map((item, index) => (
                                        <tr>
                                            <td><div className={"form-control border-0"}>{index+1}</div></td>
                                            <td>
                                                <FormGroup>
                                                    <Input
                                                        type="text"
                                                        name="label"
                                                        value={item.label ? item.label : ""}
                                                        onChange={(e) => {
                                                            systemSpecifications[index].label = e.target.value
                                                            this.setState({
                                                                systemSpecifications: systemSpecifications,
                                                            })
                                                        }}
                                                        placeholder={label.EnterLabel}
                                                    />
                                                </FormGroup>
                                            </td>
                                            <td>
                                                <FormGroup>
                                                    <Input
                                                        type="text"
                                                        name="description"
                                                        value={item.description ? item.description : ""}
                                                        onChange={(e) => {
                                                            systemSpecifications[index].description = e.target.value
                                                            this.setState({
                                                                systemSpecifications: systemSpecifications,
                                                            })
                                                        }}
                                                        placeholder={label.EnterDescription}
                                                    />
                                                </FormGroup>
                                            </td>
                                            <td>
                                                <Button
                                                    color={"danger"}
                                                    onClick={() => {
                                                        systemSpecifications.splice(index, 1)
                                                        this.setState({
                                                            systemSpecifications: systemSpecifications
                                                        })
                                                    }}>
                                                    <MdDelete />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                }
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }
}
export default Object.assign(ModelDetailPage, {ENDPOINT : "/modelDetail"})